import { observer } from 'mobx-react-lite';
import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { useStore } from '../Stores/store';
import { UserType } from '../Models/UserType';

export const ProtectedRoutes = observer(() => {
    const { generalStore } = useStore();
    const { token } = generalStore;

    return token ? <Outlet /> : <Navigate to="/" />
});

export const DayGuestRoutes = observer(() => {
    const { generalStore } = useStore();
    const { userType } = generalStore;

    return userType === UserType.DayGuest ? <Outlet /> : userType === UserType.EveningGuest ? <Navigate to="/app" /> : <Navigate to="/" />;
});

export const EveningGuestRoutes = observer(() => {
    const { generalStore } = useStore();
    const { userType } = generalStore;

    return userType ? <Outlet /> : <Navigate to="/" />;
});
